import { Injectable, signal, TemplateRef } from '@angular/core'

@Injectable()
export class ToolbarService {
  readonly toolbarTemplateStack = signal<(TemplateRef<unknown> | undefined)[]>([])

  /**
   * Pop a template from the stack.
   * This will remove the template from the stack and update the toolbar to the new top template.
   */
  pop() {
    this.toolbarTemplateStack.update((stack) => {
      return stack.slice(0, stack.length - 1)
    })
  }

  /**
   * Push a template onto the stack.
   * This will be the template that is displayed in the toolbar.
   * @param template The template to push onto the stack.
   */
  push(template?: TemplateRef<unknown>) {
    this.toolbarTemplateStack.update((stack) => {
      return [...stack, template]
    })
  }
}
